import { push, ref } from "firebase/database";
import { database } from "../../../Utils/firebase";
import GetInvoiceDataFirebase from "./GetInvoiceDataFirebase";
import AddCustomerDataInFirebase from "../Customers/AddCustomerData";
import AddItemDataInFirebase from "../Items/AddItemDataInFirebase";

const AddInvoiceDataInFirebase = async (state, dispatch, invoiceData, userId) => {

    if ((!state?.USERID || state?.USERID == null) && !userId) return null;

    const USERID = userId ? userId : state?.USERID
    console.log("create invoice  without modification", invoiceData);
    try {

        const formatItems = (rawItems) => {
            return rawItems.map(i => ({
                // amount: i?.amount?.toString() || "0.00",
                // billId: invoiceData?.id?.toString() || "",
                // companyId: invoiceData?.companyId?.toString() || "",
                // creationDate: invoiceData?.creationDate?.toString() || new Date().getTime().toString(),
                // isSalesReturnKey: "",
                // itemId: "",
                // name: i?.name || "",
                // price: i?.price?.toString() || "",
                // quantity: ,
                // subtitle: i?.subtitle || "",
                // updateDate: invoiceData?.creationDate?.toString() || new Date().getTime().toString()
                itemId: i?.itemId?.toString() || "",
                itemAddedDate: new Date().getTime().toString() || "",
                price: i?.price?.toString() || "",
                quantity: i?.quantity?.toString() || "",
                // name: i?.name || "",
            }));
        };

        const actorName = state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest";

        // Reference to user's invoice data
        const userRef = ref(database, `invoiceGenerator/users/${USERID}/billInvoice`);

        // Push new invoice data
        await push(userRef, {
            createdBy: actorName,
            createdById: state?.USERID || null,
            updatedBy: actorName,
            updatedById: state?.USERID || null,
            companyId: invoiceData?.companyId?.toString() || "",
            creationDate: invoiceData?.creationDate?.toString() || new Date().getTime().toString(),
            customInvoiceId: invoiceData?.customInvoiceId?.toString() || "",
            customerId: invoiceData?.customerId?.toString(),
            date: (invoiceData?.date && !isNaN(invoiceData.date)) ? invoiceData.date.toString() : "",
            discountAmount: invoiceData?.discountAmount?.toString() || "0.00",
            discountPercetage: invoiceData?.discountPercetage?.toString() || "0",
            dueDate: (invoiceData?.dateDue && !isNaN(invoiceData.dateDue)) ? invoiceData.dateDue.toString() : "",
            gstAmount: invoiceData?.gstAmount?.toString() || "0.00",
            pstAmount: invoiceData?.pstAmount?.toString() || "0.00",
            pstPercentage: invoiceData?.pstPercentage?.toString() || "0",
            gstPercetage: invoiceData?.gstPercentage?.toString() || invoiceData?.gstPercetage?.toString() || "0",
            id: invoiceData?.id?.toString() || "",
            invoiceId: invoiceData?.invoiceId?.toString() || "",
            isigst: invoiceData?.isigst || invoiceData?.igst == true ? "true" : "false",
            note: invoiceData?.note?.toString() || "",
            paidFlagKey: invoiceData?.isPaid ? "true" : "false",
            platform: "website",
            totalAmount: invoiceData?.totalAmount?.toString() || "",
            updateDate: invoiceData?.creationDate?.toString() || new Date().getTime().toString(),
            version: process.env.REACT_APP_VERSION,
            items: formatItems(invoiceData?.items),
            shippingaddress: invoiceData?.shippingaddress || "",
            isDeleted: false,
            currency: invoiceData?.currency?.toString() || "",
            dialCode: invoiceData?.dialCode?.toString() || "",
            phone: invoiceData?.phone?.toString() || "",
            email: invoiceData?.email?.toString() || "",
            address: invoiceData?.address?.toString() || "",
            customer: invoiceData?.customer?.toString() || "",
            customerGSTNo: invoiceData?.customerGSTNo?.toString() || "",
            pstAmount: invoiceData?.pstAmount?.toString() || "",
            pstPercentage: invoiceData?.pstPercentage?.toString() || "",

            // customer: invoiceData?.customer?.toString() || "",
            // customerGSTNo: invoiceData?.customerGSTNo?.toString() || "",
            // date: invoiceData.date.toString() || new Date().getTime().toString(),

            // email: invoiceData?.email?.toString() || "",

            // items: formatItems(invoiceData?.items),
            // phone: invoiceData?.phone?.toString() || "",

        });

        const customer = {
            companyId: invoiceData?.companyId?.toString() || "",
            customer: invoiceData?.customer?.toString() || "",
            customerGSTNo: invoiceData?.customerGSTNo?.toString() || "",
            phone: invoiceData?.phone?.toString() || "",
            email: invoiceData?.email?.toString() || "",
            createdAt: invoiceData?.creationDate?.toString() || new Date().getTime().toString(),
            updatedAt: invoiceData.creationDate.toString() || new Date().getTime().toString(),
            invoiceCount: "1",
            invoices: [invoiceData?.invoiceId?.toString()],
            outstanding: invoiceData?.totalAmount?.toString() || "0",
            totalAmount: invoiceData?.totalAmount?.toString() || "0",
            totalPaid: "0",
            address: invoiceData?.address?.toString() || ""
        }

        // AddCustomerDataInFirebase(state, dispatch, customer)

        // AddItemDataInFirebase(state, dispatch, formatItems(invoiceData?.items))

        // Fetch updated invoice data
        await GetInvoiceDataFirebase(state, dispatch);

        return { success: true, message: "New invoice added successfully!" };
    } catch (error) {
        return { success: false, message: error };
    }
};

export default AddInvoiceDataInFirebase;
